import { readonlyTextCell } from "@dashboard/components/Datagrid/customCells/cells";
import { AvailableColumn } from "@dashboard/components/Datagrid/types";
import { Item } from "@glideapps/glide-data-grid";
import { IntlShape } from "react-intl";

export interface VendorListedProduct {
  id: string;
  name: string;
  created: string;
  updatedAt: string;
  description?: string;
  price?: string;
  type?: string;
}

export const vendorOfferingsStaticColumnsAdapter = (
  _intl: IntlShape,
): AvailableColumn[] =>
  [
    {
      id: "name", 
      title: "Product",
      width: 300,
    },
    {
      id: "description",
      title: "Description", 
      width: 300,
    },
    {
      id: "price",
      title: "Price",
      width: 150,
    },
    {
      id: "type",
      title: "Type",
      width: 200,
    },
    {
      id: "updatedAt",
      title: "Last updated",
      width: 200,
    },
    {
      id: "createdAt",
      title: "Created",
      width: 200,
    },
  ];

export function createGetCellContent(
  products: VendorListedProduct[],
  columns: AvailableColumn[],
) {
  return ([column, row]: Item) => {
    const columnId = columns[column]?.id;
    const rowData = products[row];

    if (!columnId || !rowData) {
      return readonlyTextCell("");
    }

    switch (columnId) {
      case "id":
        return readonlyTextCell(rowData.id);
      case "name":
        return readonlyTextCell(rowData.name);  
      case "description":
        return readonlyTextCell(rowData.description || rowData.name);
      case "price":
        return readonlyTextCell(rowData.price || "Select channel");
      case "type":
        return readonlyTextCell(rowData.type || "Default Type");
      case "createdAt":
      case "created":
        return readonlyTextCell(new Date(rowData.created).toLocaleDateString());
      case "updatedAt":
      case "updated":
        return readonlyTextCell(new Date(rowData.updatedAt).toLocaleDateString());
      default:
        return readonlyTextCell("");
    }
  };
}